import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Column, ConfirmationModal, TextField, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export const GetDeleteAccountConfirmationModalTID = (parentTestId)=>getTestIds(parentTestId);
export function DeleteAccountConfirmationModal(props) {
    const { expectedEmail, dismissModal } = props;
    const { t: deleteAccountTexts } = useLocaleKeys('pages.profile.deleteAccount');
    const { DeleteAccountConfirmationModalTestIds } = useMemo(()=>GetDeleteAccountConfirmationModalTID(), []);
    const { control, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            email: ''
        }
    });
    const validateEmail = (value)=>{
        const normalize = (email)=>email.trim().toLowerCase();
        return normalize(value) === normalize(expectedEmail) || deleteAccountTexts.emailMismatch();
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'delete_account_confirm'
            },
            secondaryButton: {
                name: 'delete_account_cancel'
            }
        },
        title: deleteAccountTexts.confirmTitle(),
        skin: "danger",
        textAlignCenter: false,
        primaryButtonLabel: deleteAccountTexts.confirmButton(),
        secondaryButtonLabel: deleteAccountTexts.cancel(),
        onPrimaryButtonClick: handleSubmit(()=>dismissModal({
                confirmed: true
            })),
        onSecondaryButtonClick: ()=>dismissModal({
                confirmed: false
            }),
        content: /*#__PURE__*/ _jsxs(Column, {
            gap: 16,
            style: {
                paddingBottom: 24
            },
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: deleteAccountTexts.confirmContent()
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    name: "email",
                    control: control,
                    rules: {
                        validate: validateEmail
                    },
                    render: (p)=>/*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                            bi: {
                                name: 'delete_account_email_confirm'
                            }
                        }, connectControllerToTextField(p)), {
                            label: deleteAccountTexts.emailVerifyLabel(),
                            type: "email",
                            testId: DeleteAccountConfirmationModalTestIds.EmailVerification()
                        }))
                })
            ]
        })
    });
}
